const JobCardSkeleton = () => (
    <div className='job-card-list skeleton-job-card'>
      <div className='job-card-left'>
        <div className='job-logo skeleton-box' />
      </div>
      <div className='job-card-middle'>
        <div className='job-listing-header'>
          <div className='skeleton-box skeleton-job-card-title' />
          <div className='job-listing-actions'>
            <div className='skeleton-box heart-icon' />
            <div className='skeleton-box apply-button' />
          </div>
        </div>
        <div className='skeleton-box job-company-name' />
        <div className='skeleton-box job-location' />
        <hr className='job-listing-divider' />
        <div className='skeleton-tags'>
          <div className='skeleton-box job-tags' />
        </div>
      </div>
    </div>
  );

  export default JobCardSkeleton;
  